import React, {useEffect, useState} from 'react';
import {LessonEditor} from '../../../LessonEditor';
import {inject, observer} from 'mobx-react';
import {useNavigate, useParams} from 'react-router-dom';
import {Microlesson} from '../../../../data/models/Microlessons/Microlesson';
import MicrolessonEditorStore from '../store/MicrolessonEditorStore';

interface Props {
  microlessonEditorStore?: MicrolessonEditorStore;
}

const MicrolessonEditorContainer = inject('microlessonEditorStore')(
  observer(({microlessonEditorStore}: Props) => {
    const [lesson, setLesson] = useState<Microlesson>();

    const navigate = useNavigate();
    const {organizationId, lessonId} = useParams();

    useEffect(() => {
      if (organizationId && lessonId) {
        microlessonEditorStore!
          .getMicrolessonById(organizationId, lessonId)
          .then(setLesson);
      }
    }, [lessonId]);

    const getBreadcrumbs = () => [
      {
        title: 'Lessons',
        link: `/manage/${organizationId}/microlessons`,
      },
      {
        title: lesson!.title,
        link: `#`,
      },
    ];

    const onBack = () => {
      navigate(`/manage/${organizationId}/microlessons`, {replace: true});
    };

    const onPreview = () => {
      navigate(`/preview/${organizationId}/microlesson/${lessonId}`);
    };

    return lesson ? (
      <LessonEditor
        breadcrumbs={getBreadcrumbs()}
        isGradable={lesson.isGradable}
        onBack={onBack}
        onPreview={onPreview}
        lessonTitle={lesson.title}
        currentLessonId={lesson.id}
        hideSidebar
      />
    ) : (
      <div />
    );
  }),
);

export default MicrolessonEditorContainer;
